import { buildHowToPlayProps } from './blocks/buildHowToPlayProps';
import { buildTimelineProps } from './blocks/buildTimelineProps';
import { buildGamificationMonstersProps } from './blocks/buildGamificationMonstersProps';
import { buildStarsChallengeProps } from './blocks/buildStarsChallengeProps';
import { buildFinalHighlightsProps } from './blocks/buildFinalHighlightsProps';
import { buildPromoBlockProps } from './blocks/buildPromoBlockProps';
import { buildVideoGalleryProps } from './blocks/buildVideoGalleryProps';
import { buildToolboxProps } from './blocks/buildToolboxProps';


export const buildContestInfoProps = (state, authState) => {

  const { blocks } = state?.contentInfoJson || [];
  const resolveBlockProps = (block) => {
    switch (block.type) {
      case 'howToPlay':
        return buildHowToPlayProps(block, state, authState);
      case 'timeline':
        return buildTimelineProps(block, state);
      case 'gamificationMonsters':
        return buildGamificationMonstersProps(block, state, authState);
      case 'starsChallenge':
        return buildStarsChallengeProps(block, state, authState);
      case 'finalHighlights':
        return buildFinalHighlightsProps(block, state, authState);
      case 'toolbox':
        return buildToolboxProps(block, state, authState);
      case 'promoBlock':
        return buildPromoBlockProps(block, state);
      case 'videoGallery':
        return buildVideoGalleryProps(block, state);
      default:
        return {
          id: block.id,
          type: block.type,
          props: block.props || {}
        };
    }
  };

  return {
    blocks: blocks?.map(b => resolveBlockProps(b)).filter(b => b !== null)
  };
};
